<template>
  <div>

    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center no-padding-bottom">
        <span class="mask bg-gradient-danger opacity-8"></span>
    </base-header>


    <div class="container-fluid mt--7">
        <div class="row">
            <div class="col-xl-12 order-xl-1">
                <card shadow type="secondary">
                    <div slot="header" class="bg-white border-0">
                        <div class="row align-items-center">
                            <div class="col-12">
                                <h3 class="mb-0 text-uppercase">{{ this.$route.name }}</h3>
                                <br>
                                <span class="text-danger">
                                    Verification of two-factor authentication.
                                </span>
                            </div>
                            
                        </div>
                    </div>

                    <div class="row justify-content-center">
                      <div class="col-lg-5 col-md-7">
                          <div class="card bg-secondary shadow border-0">
                              <div class="card-body px-lg-5 py-lg-5">

                                  <form role="form">
                                      <div class="text-center text-muted mb-4">
                                          <h2>Verify it's you</h2>
                                          <strong>{{ methodHint }}</strong>
                                      </div>

                                      <base-alert type="warning" dismissible v-if="showErrorBlade">
                                          <span class="alert-inner--icon"><i class="ni ni-sound-wave"></i></span>
                                          &nbsp;
                                          <span class="alert-inner--text" v-text="errorMessage"></span>
                                          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                              <span aria-hidden="true">&times;</span>
                                          </button>
                                      </base-alert>

                                      <div class="text-center mb-4 method-tabs">
                                          <base-button
                                              size="sm"
                                              :type="method === 'totp' ? 'success' : 'secondary'"
                                              @click="selectMethod('totp')">
                                              Authenticator App
                                          </base-button>
                                          <base-button
                                              size="sm"
                                              :type="method === 'email' ? 'success' : 'secondary'"
                                              @click="selectMethod('email')">
                                              Email Code
                                          </base-button>
                                          <!-- SMS temporarily hidden — backend support is already in place.
                                              Re-enable by uncommenting this button when you're ready:
                                          <base-button
                                              v-if="hasPhone"
                                              size="sm"
                                              :type="method === 'sms' ? 'success' : 'secondary'"
                                              @click="selectMethod('sms')">
                                              Text Message
                                          </base-button>
                                          -->
                                          <base-button
                                              size="sm"
                                              :type="method === 'recovery' ? 'success' : 'secondary'"
                                              @click="selectMethod('recovery')">
                                              Recovery Code
                                          </base-button>
                                      </div>

                                      <p class="text-center text-muted mb-3" v-if="method === 'email' || method === 'sms'">
                                          We sent a code to your {{ method === 'email' ? 'email' : 'phone' }}.
                                          <a href="#" @click.prevent="resend">
                                            {{ isLoading2 ? 'Please Wait...' : 'Resend' }}
                                          </a>
                                      </p>

                                      <base-input class="input-group-alternative mb-3"
                                                  :placeholder="method === 'recovery' ? 'XXXX-XXXX' : '6-digit code'"
                                                  addon-left-icon="ni ni-lock-circle-open"
                                                  :valid="validCodeStatus"
                                                  @change="changeStatus"
                                                  @keyup.enter="submit()"
                                                  v-model="model.code">
                                      </base-input>

                                      <div class="text-center">
                                          <base-button
                                              type="success" class="my-4"
                                              @click="submit"
                                              v-if="! isLoading">
                                              Verify
                                          </base-button>
                                          <button class="btn btn-success" type="button" disabled v-if="isLoading">
                                              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                              Please Wait...
                                          </button>
                                      </div>
                                  </form>
                              </div>
                          </div>
                      </div>
                  </div>


                </card>
            </div>
        </div>
    </div>
        
  </div>





    
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import axios from 'axios';
    import swal from 'sweetalert2';

    export default {
        name: 'MfaChallenge',
        data() {
            return {
                model: {
                    code: ''
                },
                method: 'totp',
                hasPhone: false,
                isLoading: false,
                showErrorBlade: false,
                errorMessage: '',
                validCodeStatus: null,
                isLoading2: false
            }
        },
        computed: {
            ...mapGetters(['getHospitalAccessToken', 'getPreferredMethod', 'getRootUrl']),
            methodHint() {
                if (this.method === 'recovery') {
                    return 'Enter one of your saved recovery codes';
                }
                if (this.method === 'email') {
                    return 'Enter the code sent to your email';
                }
                if (this.method === 'sms') {
                    return 'Enter the code sent to your phone';
                }
                return 'Enter the 6-digit code from your authenticator app';
            }
        },
        mounted() {
            // Default to whichever method the account enrolled with.
            this.method = this.getPreferredMethod || 'totp';
            if (this.method === 'email' || this.method === 'sms') {
                this.sendOtp(this.method);
            }
        },
        methods: {
            ...mapActions(['storeAndLoginUser', 'destroyAccessToken']),
            selectMethod(method) {
                this.method = method;
                this.model.code = '';
                this.showErrorBlade = false;
                this.validCodeStatus = null;
                if (method === 'email' || method === 'sms') {
                    this.sendOtp(method);
                }
            },
            resend() {
                this.sendOtp(this.method);
            },
            sendOtp(channel) {
                this.isLoading2 = true;
                axios.post(this.getRootUrl+'/mfa/challenge/send-otp', {
                    pending_token: this.getHospitalAccessToken,
                    channel
                }).then(() => {
                  this.isLoading2 = false;
                }).catch(() => {
                  this.isLoading2 = false;
                    swal.fire("Network Failure!", 'Could not send a code. Kindly try again', "warning");
                });
            },
            submit() {
                this.showErrorBlade = false;
                this.isLoading = true;
                if (! this.model.code) {
                    this.isLoading = false;
                    return this.showError('Enter a code to continue');
                }
                axios.post(this.getRootUrl+'/mfa/challenge/verify', {
                    pending_token: this.getHospitalAccessToken,
                    method: this.method,
                    code: this.model.code
                })
                .then((res) => {
                    this.isLoading = false;
                    this.storeAndLoginUser(res.data); // stores the full-access token
                    return window.location.href = '/';
                })
                .catch((err) => {
                    this.isLoading = false;
                    this.validCodeStatus = false;
                    this.destroyAccessToken();
                    this.showError(this.errMsg(err, 'Invalid or expired code. Kindly try again'));
                });
            },
            errMsg(err, fallback) {
                return (err.response && err.response.data && err.response.data.message) || fallback;
            },
            showError(msg) {
                this.showErrorBlade = false;
                this.errorMessage = '';
                this.showErrorBlade = true;
                this.errorMessage = msg;
            },
            changeStatus() {
                this.showErrorBlade = false;
                this.validCodeStatus = this.model.code ? true : false;
            }
        }
    }
</script>

<style scoped>
    .method-tabs .btn {
        margin: 0 0.25rem 0.5rem;
    }
</style>
